import { BaseHomeSchema } from './baseHomeSchema'

type ContructorParams = {
  option: string
}

export abstract class BaseSelectSchema extends BaseHomeSchema {
  private option: string

  constructor({ option }: ContructorParams) {
    super()

    this.option = option
  }

  protected prepare() {
    return {
      ...super.prepare(),
      option: this.option
    }
  }
}
